import { render, staticRenderFns } from "./BrokersForm.vue?vue&type=template&id=0084db66&"
import script from "./BrokersForm.vue?vue&type=script&lang=js&"
export * from "./BrokersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports